import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { BaseServices } from '../kuba.services';
import { SJAFormServices } from './sjaform.routing';
import { FeatureKey, Roles } from 'src/app/_models';

@Injectable()
export class SJAFormListResolver {
  constructor(private backend: SJAFormServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    let roleId = Number(BaseServices.roleId);
    if (roleId !== Roles.PORTAL && roleId !== Roles.ADMIN) {
      const workingModule = JSON.parse(sessionStorage.getItem('workingModule'));
      // SJA Form List in the "Follow Up"-Module
      if (workingModule.id === FeatureKey.FOLLOW_UP) {
        return this.backend.getFollowUpSJAFormList(BaseServices.BusinessId);
      }

      // SJA Form List in other modules
      const featureKey = route.params['Id'];
      return this.backend.getSJAFormList(workingModule.id, featureKey);
    }
    return null;
  }
}

@Injectable()
export class SJAFormResolver {
  constructor(private backend: SJAFormServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getSJAForm(+route.params['Id']);
  }
}

@Injectable()
export class SJATitleListResolver {
  constructor(private backend: SJAFormServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.GetSJATitleList();
  }
}
